import React from 'react';
import { renderToString } from 'react-dom/server';
import {
	Wrapper,
	BudgetWrapper,
	GreyWrapper,
	TargetWrapper,
} from './MiniChartCellRenderer.styles';

export const MiniChartCellRenderer = ({ data }) => {
	const { actual, original, forecast } = data;

	const max = Math.max(actual, forecast, original);
	const min = Math.min(actual, forecast, original);
	const maxWidth =
		max < 0 && min < 0 ? Math.abs(min) : max >= 0 && min >= 0 ? max : max - min;

	const originalWidth = Math.round((Math.abs(original) / maxWidth) * 100);
	const actualWidth = Math.round((Math.abs(actual) / maxWidth) * 100);
	const forecastValue = min < 0 ? min - forecast : forecast;
	const forecastWidth = Math.round((Math.abs(forecastValue) / maxWidth) * 100);
	const getOffset = value => {
		const offsetValue =
			value >= 0 && min < 0
				? Math.abs(min)
				: value < 0
					? Math.abs(min - value)
					: 0;
		return Math.round((offsetValue / maxWidth) * 100);
	};

	const offsetOriginal = getOffset(original);
	const offsetActual = getOffset(actual);
	const isOverrun = actual > forecast;

	return renderToString(
		<Wrapper>
			<GreyWrapper width={originalWidth} offset={offsetOriginal} />
			<BudgetWrapper
				width={actualWidth}
				isOverrun={isOverrun}
				offset={offsetActual}
			/>
			<TargetWrapper width={forecastWidth} />
		</Wrapper>
	);
};
